import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface UsersProps extends CacheProps{
  sort: string
  page: number
  limit: number
  filters?: {
    provinceId: string,
    workHour: string,
    serviceTypeId: string,
    specialtyId: string,
    specialtiesTypeId: string,
    searchValue: string,
  }
}

const getUsersFromAPI = async ({ sort, page, limit, filters, ...rest }: UsersProps) => {
  const res = await fetchApi({
    method: 'POST',
    URL: routes['api.users.datatable'],
    payload: {
      type_id: 1,
      sort: sort,
      direction: 'desc',
      limit: limit,
      page: page,
      specialty_id: filters?.specialtyId,
      specialty_type_id: filters?.specialtiesTypeId,
      province_id: filters?.provinceId,
      service_type_id: filters?.serviceTypeId,
      work_hours: filters?.workHour,
      full_name: filters?.searchValue,
    },
    ...rest,
  });

  return res?.data;
};

export default getUsersFromAPI;
